
//出库下单-选择下单类型dom监控扩展类
class QuickTypeNav {
  private config: any = {};
  constructor(config: { selector: string, extFieldName?: string }) {
    this.config = config;
  }
  getExt() {
    let el = document.querySelector(this.config.selector);
    let checkedBox = el?.querySelector('.preference-list-item__active');
    let quickCheckedLabel = checkedBox?.getAttribute('data-monitor-fieldlabel');
    let quickCheckedKey = checkedBox?.getAttribute('data-monitor-fieldkey');
    let checkedEl = checkedBox?.querySelector('.winitd-checkbox-checked');
    if (checkedEl) {
      quickCheckedKey = checkedEl?.querySelector('.winitd-checkbox-input')?.getAttribute('value');
      quickCheckedLabel = (checkedEl?.nextSibling as HTMLElement)?.innerText?.trim();
    }
    if (!quickCheckedLabel) return null;
    return {
      [this.config.extFieldName || 'quickOrderTypeLabel']: quickCheckedLabel,
      'quickOrderTypeKey': quickCheckedKey,
    };
  }
  private createObserver() {
  }
  start() {

  };
  stop() {
  }
}

export default QuickTypeNav;
